import { render, staticRenderFns } from "./SocietyMatchWizardsStepThree.vue?vue&type=template&id=33c3f521&scoped=true"
import script from "./SocietyMatchWizardsStepThree.vue?vue&type=script&lang=js"
export * from "./SocietyMatchWizardsStepThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c3f521",
  null
  
)

export default component.exports